module.exports = __webpack_public_path__ + "assets/img/icon_lesson_quiz.43aa3c22.png";